package dev.lingvo.site.pages.app.projects.slug.translate

import androidx.compose.runtime.Composable
import com.varabyte.kobweb.core.Page
import com.varabyte.kobweb.core.layout.Layout
import com.varabyte.kobweb.core.rememberPageContext
import dev.lingvo.shared.ReviewStatus
import dev.lingvo.site.components.editor.TranslationEditorScreen

@Page("/app/projects/{slug}/translate/{locale}")
@Layout(".components.layouts.EditorLayout")
@Composable
fun TranslationEditorPage() {
    val ctx = rememberPageContext()
    TranslationEditorScreen(
        projectSlug = ctx.route.params["slug"].orEmpty(),
        locale = ctx.route.params["locale"].orEmpty(),
        initialKeyId = ctx.route.params["key"],
        initialSearch = ctx.route.params["search"].orEmpty(),
        // Minted by the work queue, which promises an exact set: "12 strings with changes
        // requested". Unparseable is absent — a stale link should open the editor, not an error.
        initialReview = ctx.route.params["review"]
            ?.let { value -> ReviewStatus.entries.firstOrNull { it.name.equals(value, ignoreCase = true) } },
        initialStale = ctx.route.params["stale"].equals("true", ignoreCase = true),
        // `?state=untranslated|translated|approved`, so every counter in the product can open the
        // editor on what is left rather than on everything.
        initialState = ctx.route.params["state"],
    )
}
